(function () {
  'use strict';
  if (window.__ksSizeHelperLoaded) return;
  window.__ksSizeHelperLoaded = true;
 
  var I = {
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15.5L15.5 3 21 8.5 8.5 21z"/><path d="M7 11.5l2 2M10 8.5l2 2M13 5.5l2 2"/></svg>',
    chev:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.4v.2"/></svg>',
    info:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.6v.2"/></svg>',
    user:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="3.6"/><path d="M4.5 20c.9-3.8 4-5.8 7.5-5.8s6.6 2 7.5 5.8"/></svg>',
    plus:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    edit:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/></svg>'
  };
 
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function trim(n) { return (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, ''); }
  /* "[size] selected for [name]" — the template is escaped first, the
     values are already safe HTML. */
  function fill(tpl, map) {
    return esc(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  /* the same, for textContent: nothing escaped, nothing interpreted */
  function plain(tpl, map) {
    return String(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }
  function usOf(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
 
  function init(root) {
    if (!root || root.getAttribute('data-ksh-ready') === '1') return;
    var KS = window.KSFinder;
    var cfgEl = root.querySelector('[data-ksh-config]');
    if (!KS || typeof KS.build !== 'function' || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var me = KS.build(cfg.product);
    if (!me) return;
 
    /* ---------- the theme's own size and color pickers ---------- */
    var scope = root.closest('.shopify-section') || document;
    var SIZE_KEY = 'option' + cfg.sizePos, COLOR_KEY = 'option' + cfg.colorPos;
    function firstIn(el, key) {
      return el.querySelector('input[type=radio][data-index="' + key + '"]') ||
             el.querySelector('select[data-index="' + key + '"]');
    }
    var sAnchor = firstIn(scope, SIZE_KEY);
    if (!sAnchor) return;
    var sizeWrap = sAnchor.closest('.variant-wrapper') || sAnchor.closest('fieldset') || sAnchor.parentNode;
    var cAnchor = cfg.colorPos ? firstIn(scope, COLOR_KEY) : null;
    var colorWrap = cAnchor ? (cAnchor.closest('.variant-wrapper') || cAnchor.closest('fieldset') || cAnchor.parentNode) : null;
 
    function radios(wrap, key) {
      return wrap ? Array.prototype.slice.call(wrap.querySelectorAll('input[type=radio][data-index="' + key + '"]')) : [];
    }
    function current(wrap, key) {
      var r = radios(wrap, key).filter(function (x) { return x.checked; })[0];
      if (r) return r.value;
      var s = wrap ? wrap.querySelector('select[data-index="' + key + '"]') : null;
      return s ? s.value : '';
    }
    function choose(wrap, key, value) {
      var r = radios(wrap, key).filter(function (x) { return x.value === value; })[0];
      if (r) {
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncTheme(0);
        return true;
      }
      var s = wrap ? wrap.querySelector('select[data-index="' + key + '"]') : null;
      if (s && Array.prototype.some.call(s.options, function (o) { return o.value === value; })) {
        if (s.value !== value) {
          s.value = value;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
      return false;
    }
    /* The option value exactly as Shopify stores it ("7", "7.0", "US 7") */
    function sizeValue(us) {
      var s = cfg.product.s || [];
      for (var i = 0; i < s.length; i++) if (usOf(s[i]) === us) return s[i];
      return String(us);
    }
    function colorsWith(us) {
      var out = [];
      (cfg.variants || []).forEach(function (v) {
        if (v.a && usOf(v.s) === us && v.c && out.indexOf(v.c) < 0) out.push(v.c);
      });
      return out;
    }
    /* The theme only listens once its own script has started, which can
       be after this one has already picked the size. Until the variant
       the cart will receive matches the buttons, keep telling it. */
    var syncT = null;
    function variantNow() {
      var us = usOf(current(sizeWrap, SIZE_KEY));
      var c = colorWrap ? current(colorWrap, COLOR_KEY) : '';
      return (cfg.variants || []).filter(function (v) {
        return usOf(v.s) === us && (!cfg.colorPos || v.c === c);
      })[0] || null;
    }
    function syncTheme(tries) {
      clearTimeout(syncT);
      var want = variantNow();
      var master = scope.querySelector('form[action*="/cart/add"] [name="id"]') || scope.querySelector('[name="id"]');
      if (!want || !want.id || !master || String(master.value) === String(want.id) || tries > 32) return;
      syncT = setTimeout(function () {
        var r = radios(sizeWrap, SIZE_KEY).filter(function (x) { return x.checked; })[0];
        if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
        syncTheme(tries + 1);
      }, tries ? 250 : 60);
    }
    function inStock(us, color) {
      return (cfg.variants || []).some(function (v) {
        return v.a && usOf(v.s) === us && (!color || !cfg.colorPos || v.c === color);
      });
    }
 
    /* Sits right under the size buttons (or above them). */
    if (sizeWrap.parentNode) {
      sizeWrap.parentNode.insertBefore(root, cfg.pos === 'above' ? sizeWrap : sizeWrap.nextSibling);
    }
    root.setAttribute('data-ksh-ready', '1');
 
    /* ---------- texts ---------- */
    var SV = KS.sizes && KS.sizes.on ? KS.sizes : null;
    var T = cfg.t || {};
    var ST = (KS.sizes && KS.sizes.t) || {};
    function tx(k, d) {
      var v = T[k];
      if (v == null || v === '') v = ST[k];
      return v == null || v === '' ? d : v;
    }
    function sizeTxt(p) { return 'US ' + p.us + (!isNaN(p.eu) ? ' · EU ' + p.eu : ''); }
    function ageTxt(m) { return m === 1 ? '1 month' : m + ' months'; }
 
    /* ---------- state ---------- */
    var last = KS.recall ? (KS.recall() || {}) : {};
    var FIRST = me.rows[0][1] - KS.maxRoom, LAST = me.rows[me.rows.length - 1][1] - KS.minRoom;
    var RMIN = Math.min(13, Math.floor(FIRST) - 1), RMAX = Math.max(30, Math.ceil(LAST) + 1);
    var DEF = last.foot >= RMIN && last.foot <= RMAX ? +last.foot : 22;
 
    var S = {
      src: null,      /* 'p' a saved size, 'm' measured in the panel, 'u' from the link */
      pid: '',
      foot: NaN, fit: 'comfort', socks: false,
      unit: last.unit === 'in' ? 'in' : 'cm',
      open: false,
      edit: '',       /* id of the saved size open in the panel */
      manage: false,
      flash: ''
    };
    /* what the panel is showing; only becomes S when used */
    var D = { foot: NaN, fit: 'comfort', socks: false };
 
    function rec(foot, fit, socks) {
      if (!(foot >= 10)) return null;
      var r = KS.sizeFor(me, foot, { fit: fit, socks: socks });
      if (!r) return { none: true };
      return { r: r, pick: r.best || r.bestAny, soldOut: !r.best };
    }
    function active() {
      if (S.src === 'p') {
        var p = SV ? SV.get(S.pid) : null;
        if (!p) { S.src = null; S.pid = ''; return null; }
        return { name: p.name, foot: p.foot, fit: p.fit, socks: p.socks, prof: p };
      }
      if (S.src === 'm' || S.src === 'u') return { name: '', foot: S.foot, fit: S.fit, socks: S.socks, prof: null };
      return null;
    }
    function lenTxt(cm) { return S.unit === 'in' ? (cm / 2.54).toFixed(2) + ' in' : trim(cm) + ' cm'; }
    function finderUrl(a) {
      var u = cfg.finder || '/pages/size-finder';
      if (!a || !(a.foot >= 10)) return u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim(a.foot) + '&ks_fit=' + a.fit + (a.socks ? '&ks_socks=1' : '');
    }
 
    /* ---------- select the size for whoever is active ---------- */
    function apply(source) {
      var a = active();
      if (!a) { paint(); return; }
      var x = rec(a.foot, a.fit, a.socks);
      if (x && !x.none && !x.soldOut) {
        if (choose(sizeWrap, SIZE_KEY, sizeValue(x.pick.us))) {
          KS.track('ks_helper_select', { model: me.title, size: x.pick.us, source: source, foot_cm: a.foot, fit: a.fit });
        }
      }
      paint();
    }
 
    /* ---------- skeleton ---------- */
    var hasSave = !!SV;
    root.innerHTML =
      '<div data-top></div>' +
      '<div class="ksh-status" data-status aria-live="polite" hidden></div>' +
      '<div class="ksh-panel" data-panel hidden>' +
        '<div class="ksh-ph"><span class="ksh-lab">' + esc(tx('foot', 'Foot length')) + '</span>' +
          '<div class="ksh-seg" role="group" aria-label="Unit"><button type="button" data-unit="cm">cm</button><button type="button" data-unit="in">in</button></div></div>' +
        '<div class="ksh-dial">' +
          '<button type="button" class="ksh-pm" data-inc="-1" aria-label="Shorter">' + I.minus + '</button>' +
          '<label class="ksh-num"><input type="number" inputmode="decimal" step="0.1" min="5" max="40" aria-label="' + esc(tx('foot', 'Foot length')) + '" data-foot><span data-unitlab>cm</span></label>' +
          '<button type="button" class="ksh-pm" data-inc="1" aria-label="Longer">' + I.plus + '</button>' +
        '</div>' +
        '<input type="range" class="ksh-range" data-range min="' + RMIN + '" max="' + RMAX + '" step="0.1" value="' + DEF + '" aria-label="' + esc(tx('foot', 'Foot length')) + '">' +
        (cfg.howto ? '<p class="ksh-howto">' + I.info + '<span>' + esc(tx('howto', 'Stand on paper with your heel against a wall. Mark the tip of the longest toe and measure from the wall to the mark.')) + '</span></p>' : '') +
        '<div class="ksh-fits" role="group" aria-label="Fit">' +
          ['snug', 'comfort', 'grow'].map(function (k) {
            return '<button type="button" class="ksh-fit" data-fit="' + k + '" aria-pressed="false"><b>' + esc(KS.fits[k].label) + '</b><small>+' + KS.fits[k].target + ' cm</small></button>';
          }).join('') +
        '</div>' +
        '<div class="ksh-res" data-res aria-live="polite"></div>' +
        (hasSave ?
          '<div class="ksh-save">' +
            '<span class="ksh-lab" data-savelab>' + esc(tx('save_lab', 'Save for next time')) + '</span>' +
            '<div class="ksh-name"><input type="text" data-name maxlength="24" autocomplete="off" enterkeyhint="done" placeholder="' + esc(tx('name', 'Name, like Emma')) + '" aria-label="' + esc(tx('name', 'Name, like Emma')) + '"><button type="button" class="ksh-btn" data-save></button></div>' +
            '<div class="ksh-sugg" data-sugg></div>' +
            '<p class="ksh-msg" data-msg role="alert" hidden></p>' +
            '<p class="ksh-fine">' + esc(tx('private', 'Saved on this device only.')) + '</p>' +
          '</div>' : '') +
        '<div class="ksh-pf">' +
          '<button type="button" class="ksh-del" data-del hidden></button>' +
          '<a class="ksh-link" data-finder href="' + esc(finderUrl(null)) + '">' + esc(tx('finder', 'Open the size finder')) + '</a>' +
          '<button type="button" class="ksh-link ksh-close" data-close>' + esc(tx('close', 'Close')) + '</button>' +
        '</div>' +
      '</div>';
 
    function $(s) { return root.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    var top = $('[data-top]'), status = $('[data-status]'), panel = $('[data-panel]');
    var input = $('[data-foot]'), range = $('[data-range]'), nameIn = $('[data-name]');
 
    /* ---------- painting ---------- */
    var lastTop = null;
    function paintTop() {
      var list = SV ? SV.list() : [];
      var html = '';
      if (list.length) {
        if (!list.some(function (p) { return p.id === S.edit; }) && S.edit) S.edit = '';
        html =
          '<div class="ksh-head"><span class="ksh-lab">' + I.user + esc(tx('saved', 'Saved sizes')) + '</span>' +
            '<button type="button" class="ksh-txt" data-manage aria-pressed="' + S.manage + '">' + esc(S.manage ? tx('done', 'Done') : tx('edit', 'Edit')) + '</button></div>' +
          '<div class="ksh-chips' + (S.manage ? ' is-manage' : '') + '">' +
            list.map(function (p) {
              var x = rec(p.foot, p.fit, p.socks);
              var na = !x || x.none || x.soldOut;
              var sub = !x || x.none ? tx('chip_none', 'not made') : 'US ' + x.pick.us + (x.soldOut ? ' · ' + tx('chip_out', 'sold out') : '');
              var on = S.manage ? S.edit === p.id : S.src === 'p' && S.pid === p.id;
              return '<button type="button" class="ksh-chip' + (on ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-pid="' + esc(p.id) + '" aria-pressed="' + on + '">' +
                (S.manage ? I.edit : on ? I.check : '') + '<b>' + esc(p.name) + '</b><span>' + esc(sub) + '</span></button>';
            }).join('') +
            (list.length < SV.max && !S.manage ? '<button type="button" class="ksh-chip ksh-chip--add" data-add>' + I.plus + '<b>' + esc(tx('add', 'Add a size')) + '</b></button>' : '') +
          '</div>';
      } else if (cfg.empty !== 'hide') {
        var inner = '<span class="ksh-ico">' + I.ruler + '</span><span class="ksh-ct"><b>' + esc(tx('empty_q', 'Not sure which size?')) + '</b><span>' + esc(tx('empty_link', 'Find it from your foot length')) + '</span></span>';
        html = cfg.empty === 'link'
          ? '<a class="ksh-cta" href="' + esc(finderUrl(null)) + '">' + inner + I.arrow + '</a>'
          : '<button type="button" class="ksh-cta" data-open aria-expanded="' + S.open + '">' + inner + I.chev + '</button>';
      }
      if (html !== lastTop) { top.innerHTML = html; lastTop = html; }
      return list;
    }
 
    function paintStatus() {
      var a = S.open ? null : active();
      if (!a) { status.hidden = true; status.innerHTML = ''; return; }
      var x = rec(a.foot, a.fit, a.socks);
      var who = esc(a.name);
      var len = esc(lenTxt(a.foot));
      var cls = 'ok', icon = I.check, main = '', sub = '', extra = '';
 
      if (!x || x.none) {
        cls = 'warn'; icon = I.alert;
        main = a.name ? fill(tx('nosize', 'This model is not made in [name]’s size.'), { name: who })
                      : fill(tx('nosize_foot', 'This model is not made for a [length] foot.'), { length: len });
        sub = '<a class="ksh-a" href="' + esc(finderUrl(a)) + '">' + esc(tx('finder', 'Open the size finder')) + '</a>';
      } else if (x.soldOut) {
        cls = 'warn'; icon = I.alert;
        main = fill(tx('soldout', '[size] is sold out in every color.'), { size: '<b>' + esc(sizeTxt(x.pick)) + '</b>' });
        sub = '<a class="ksh-a" href="' + esc(finderUrl(a)) + '">' + esc(tx('finder', 'Open the size finder')) + '</a>';
      } else {
        var cur = usOf(current(sizeWrap, SIZE_KEY));
        var color = colorWrap ? current(colorWrap, COLOR_KEY) : '';
        var big = '<b>' + esc(sizeTxt(x.pick)) + '</b>';
        if (cur !== x.pick.us) {
          cls = 'info'; icon = I.info;
          main = (a.name ? fill(tx('here', '[name]’s size here is [size].'), { name: who, size: big })
                         : fill(tx('fits', '[size] fits a [length] foot best.'), { length: len, size: big })) +
                 ' <button type="button" class="ksh-a" data-apply>' + esc(tx('select', 'Select it')) + '</button>';
        } else if (color && !inStock(x.pick.us, color)) {
          cls = 'warn'; icon = I.alert;
          main = fill(tx('color', '[size] is sold out in [color]. In stock in:'), { size: big, color: esc(color) });
          extra = '<div class="ksh-cols">' + colorsWith(x.pick.us).map(function (c) {
            return '<button type="button" data-color="' + esc(c) + '">' + esc(c) + '</button>';
          }).join('') + '</div>';
        } else {
          main = a.name ? fill(tx('sel_name', '[size] selected for [name]'), { size: big, name: who })
                        : fill(tx('sel_foot', '[size] selected for a [length] foot'), { size: big, length: len });
          sub = fill(tx('room', '[room] cm of room at the toe'), { room: trim(x.pick.room) });
        }
      }
      if (S.flash) sub = (sub ? sub + ' · ' : '') + '<b>' + S.flash + '</b>';
      if (SV && !a.prof && x && !x.none) {
        sub = (sub ? sub + ' · ' : '') + '<button type="button" class="ksh-a" data-saveopen>' + esc(tx('save', 'Save this size')) + '</button>';
      }
      if (a.prof && SV.stale(a.prof)) {
        extra += '<p class="ksh-remind">' + fill(tx('remeasure', '[name] was measured [age] ago. Growing feet change fast.'), { name: who, age: esc(ageTxt(SV.months(a.prof))) }) +
          ' <button type="button" class="ksh-a" data-remeasure>' + esc(tx('measure_again', 'Measure again')) + '</button></p>';
      }
      status.className = 'ksh-status is-' + cls;
      status.innerHTML = icon + '<div><p>' + main + '</p>' + (sub ? '<p class="ksh-m">' + sub + '</p>' : '') + extra + '</div>';
      status.hidden = false;
    }
 
    function syncInput() {
      if (document.activeElement === input) return;
      input.value = isNaN(D.foot) ? '' : S.unit === 'in' ? (D.foot / 2.54).toFixed(2) : D.foot.toFixed(1);
    }
    function paintPanel() {
      panel.hidden = !S.open;
      if (!S.open) return;
      $$('[data-unit]').forEach(function (b) {
        var on = b.getAttribute('data-unit') === S.unit;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      $('[data-unitlab]').textContent = S.unit;
      input.step = S.unit === 'in' ? '0.05' : '0.1';
      input.placeholder = S.unit === 'in' ? (DEF / 2.54).toFixed(2) : DEF.toFixed(1);
      syncInput();
      var empty = isNaN(D.foot);
      var v = empty ? DEF : Math.min(RMAX, Math.max(RMIN, D.foot));
      if (Math.abs(+range.value - v) > 0.001) range.value = v;
      range.style.setProperty('--p', ((v - RMIN) / (RMAX - RMIN) * 100) + '%');
      range.classList.toggle('is-empty', empty);
      range.setAttribute('aria-valuetext', empty ? 'Not set' : lenTxt(D.foot));
      $$('[data-fit]').forEach(function (b) {
        var on = b.getAttribute('data-fit') === D.fit;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
 
      var res = $('[data-res]');
      var x = rec(D.foot, D.fit, D.socks);
      if (!x) { res.className = 'ksh-res'; res.innerHTML = ''; }
      else if (x.none) {
        res.className = 'ksh-res is-warn';
        res.innerHTML = I.alert + '<div><span>' + fill(tx('nosize_foot', 'This model is not made for a [length] foot.'), { length: esc(lenTxt(D.foot)) }) + '</span></div>';
      } else {
        var picked = !S.edit && usOf(current(sizeWrap, SIZE_KEY)) === x.pick.us && !x.soldOut;
        res.className = 'ksh-res ' + (x.soldOut ? 'is-warn' : 'is-ok');
        res.innerHTML = (x.soldOut ? I.alert : I.check) + '<div><b class="ksh-big">' + esc(sizeTxt(x.pick)) + '</b><span>' +
          (x.soldOut ? fill(tx('soldout', '[size] is sold out in every color.'), { size: esc(sizeTxt(x.pick)) })
                     : fill(tx('room', '[room] cm of room at the toe'), { room: trim(x.pick.room) }) + (picked ? ' · ' + esc(tx('selected', 'Selected above')) : '')) +
          '</span></div>';
      }
      var fl = $('[data-finder]');
      if (fl) fl.setAttribute('href', finderUrl(isNaN(D.foot) ? null : D));
 
      $('[data-del]').hidden = !S.edit;
      if (hasSave) paintSave();
    }
 
    function paintSave() {
      var list = SV.list();
      var raw = nameIn.value;
      var editing = S.edit ? SV.get(S.edit) : null;
      var same = !editing && SV.byName(raw);
      var btn = $('[data-save]');
      $('[data-savelab]').hidden = !!editing;
      btn.textContent = editing ? plain(tx('update', 'Update [name]'), { name: editing.name })
                      : same ? plain(tx('update', 'Update [name]'), { name: same.name })
                      : tx('save_btn', 'Save');
      btn.disabled = !(D.foot >= 10 && D.foot <= 40);
      var used = list.map(function (p) { return p.name.toLowerCase(); });
      var sugg = (SV.names || []).filter(function (n) { return used.indexOf(n.toLowerCase()) < 0; });
      if (editing) sugg = [];
      var sg = $('[data-sugg]');
      var html = sugg.map(function (n) { return '<button type="button" data-sug="' + esc(n) + '">' + esc(n) + '</button>'; }).join('');
      if (sg.innerHTML !== html) sg.innerHTML = html;
      var msg = $('[data-msg]');
      if (!editing && !same && list.length >= SV.max) {
        msg.textContent = plain(tx('full', 'You can save up to [max] sizes. Delete one first.'), { max: String(SV.max) });
        msg.hidden = false;
      } else if (msg.getAttribute('data-sticky') !== '1') {
        msg.hidden = true;
      }
    }
 
    function paint() {
      var list = paintTop();
      paintStatus();
      paintPanel();
      root.hidden = !(list.length || cfg.empty !== 'hide' || S.src || S.open);
    }
    /* a timer, not requestAnimationFrame: a tab in the background never
       runs animation frames, and the repaint would be lost for good */
    var soon = 0;
    function paintSoon() {
      if (soon) return;
      soon = setTimeout(function () { soon = 0; paint(); }, 30);
    }
 
    /* ---------- panel ---------- */
    /* p: a saved size to edit, 'blank' for a new person, or nothing to
       start from what they measured last */
    function openPanel(p, focusName) {
      S.open = true;
      S.edit = p && p.id ? p.id : '';
      if (p === 'blank') { D.foot = NaN; D.fit = 'comfort'; D.socks = false; }
      else if (p) { D.foot = p.foot; D.fit = p.fit; D.socks = !!p.socks; }
      else if (S.src === 'm' || S.src === 'u') { D.foot = S.foot; D.fit = S.fit; D.socks = S.socks; }
      else { D.foot = last.foot >= 10 ? Math.round(+last.foot * 10) / 10 : NaN; D.fit = KS.fits[last.fit] ? last.fit : 'comfort'; D.socks = !!last.socks; }
      var del = $('[data-del]');
      clearTimeout(del._t);
      del.classList.remove('is-armed');
      del.textContent = tx('del', 'Delete');
      if (nameIn) {
        nameIn.value = p && p.id ? p.name : '';
        var m = $('[data-msg]'); m.hidden = true; m.removeAttribute('data-sticky');
      }
      paint();
      KS.track('ks_helper_open', { model: me.title, mode: S.edit ? 'edit' : 'new' });
      if (focusName && nameIn) setTimeout(function () { nameIn.focus(); }, 30);
    }
    function closePanel() {
      S.open = false;
      S.edit = '';
      paint();
    }
 
    var tSel = null;
    function onDraft() {
      paintPanel();
      if (S.edit) return;
      clearTimeout(tSel);
      tSel = setTimeout(function () {
        if (!(D.foot >= 10 && D.foot <= 40)) return;
        S.src = 'm'; S.pid = '';
        S.foot = D.foot; S.fit = D.fit; S.socks = D.socks;
        if (SV) SV.pick(null);
        KS.remember({ foot: D.foot, fit: D.fit, socks: D.socks, unit: S.unit });
        apply('measure');
      }, 280);
    }
    function setDraft(cm) {
      D.foot = Math.round(cm * 100) / 100;
      onDraft();
    }
    function bump(dir) {
      var cm;
      if (S.unit === 'in') {
        var inch = isNaN(D.foot) ? Math.round(DEF / 2.54 * 20) / 20 : Math.round((D.foot / 2.54 + dir * 0.05) * 20) / 20;
        cm = inch * 2.54;
      } else {
        cm = isNaN(D.foot) ? DEF : Math.round((D.foot + dir * 0.1) * 10) / 10;
      }
      setDraft(Math.min(RMAX, Math.max(RMIN, cm)));
    }
 
    function saveMsg(text) {
      var m = $('[data-msg]');
      m.textContent = text;
      m.hidden = !text;
      if (text) m.setAttribute('data-sticky', '1'); else m.removeAttribute('data-sticky');
    }
    function doSave() {
      if (!SV) return;
      var res = SV.save({ id: S.edit || undefined, name: nameIn.value, foot: D.foot, fit: D.fit, socks: D.socks });
      if (res.error) {
        var name = SV.clean(nameIn.value);
        saveMsg(res.error === 'name' ? tx('need_name', 'Give it a name first.')
          : res.error === 'taken' ? plain(tx('taken', '[name] is already saved. Pick another name.'), { name: name })
          : res.error === 'full' ? plain(tx('full', 'You can save up to [max] sizes. Delete one first.'), { max: String(SV.max) })
          : res.error === 'foot' ? 'Set the foot length first.'
          : 'This browser did not allow saving. Private browsing can block it.');
        if (res.error === 'name') nameIn.focus();
        return;
      }
      saveMsg('');
      S.src = 'p';
      S.pid = res.item.id;
      if (cfg.keep) SV.pick(res.item.id);
      S.flash = fill(tx('saved_ok', 'Saved as [name]'), { name: esc(res.item.name) });
      S.open = false;
      S.edit = '';
      KS.remember({ foot: res.item.foot, fit: res.item.fit, socks: res.item.socks, unit: S.unit });
      apply('saved');
    }
 
    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b || !root.contains(b)) return;
      if (!b.hasAttribute('data-save')) S.flash = '';
 
      if (b.hasAttribute('data-open')) { if (S.open) closePanel(); else openPanel(null); return; }
      /* With My sizes in the header (sections/ks-shop-tools.liquid),
         Add a size and Edit open that one panel for every saved size;
         without it, they work here as before. */
      var MS = window.KSMySizes;
      if (b.hasAttribute('data-add')) { if (MS) { MS.open({ view: 'add', opener: b }); return; } openPanel('blank'); return; }
      if (b.hasAttribute('data-close')) { closePanel(); return; }
      if (b.hasAttribute('data-manage')) {
        if (MS && !S.manage) { MS.open({ view: 'list', opener: b }); return; }
        S.manage = !S.manage; if (!S.manage && S.edit) closePanel(); else paint(); return;
      }
      if (b.hasAttribute('data-pid')) {
        var p = SV && SV.get(b.getAttribute('data-pid'));
        if (!p) { paint(); return; }
        if (S.manage) { openPanel(p); return; }
        S.src = 'p'; S.pid = p.id; S.open = false; S.edit = '';
        if (cfg.keep) SV.pick(p.id);
        apply('saved');
        return;
      }
      if (b.hasAttribute('data-apply')) { apply('status'); return; }
      if (b.hasAttribute('data-color')) { choose(colorWrap, COLOR_KEY, b.getAttribute('data-color')); paintSoon(); return; }
      if (b.hasAttribute('data-saveopen')) { openPanel(null, true); return; }
      if (b.hasAttribute('data-remeasure')) {
        var a = active();
        if (a && a.prof) { if (MS) MS.open({ view: 'edit', id: a.prof.id, opener: b }); else openPanel(a.prof); }
        return;
      }
      if (b.hasAttribute('data-unit')) {
        S.unit = b.getAttribute('data-unit');
        if (!isNaN(D.foot)) KS.remember({ foot: D.foot, fit: D.fit, socks: D.socks, unit: S.unit });
        paint();
        return;
      }
      if (b.hasAttribute('data-fit')) { D.fit = b.getAttribute('data-fit'); onDraft(); return; }
      if (b.hasAttribute('data-sug')) { nameIn.value = b.getAttribute('data-sug'); saveMsg(''); paintSave(); nameIn.focus(); return; }
      if (b.hasAttribute('data-save')) { doSave(); return; }
      if (b.hasAttribute('data-del')) {
        var ed = SV && SV.get(S.edit);
        if (!ed) { closePanel(); return; }
        if (!b.classList.contains('is-armed')) {
          b.classList.add('is-armed');
          b.textContent = plain(tx('del_ask', 'Delete [name]?'), { name: ed.name });
          clearTimeout(b._t);
          b._t = setTimeout(function () { b.classList.remove('is-armed'); b.textContent = tx('del', 'Delete'); }, 4000);
          return;
        }
        SV.remove(ed.id);
        if (S.pid === ed.id) { S.src = null; S.pid = ''; }
        S.open = false; S.edit = '';
        if (!SV.list().length) S.manage = false;
        paint();
        return;
      }
    });
 
    input.addEventListener('input', function () {
      var raw = input.value.trim();
      D.foot = raw ? KS.toCm(raw, S.unit) : NaN;
      onDraft();
    });
    input.addEventListener('blur', syncInput);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    range.addEventListener('input', function () { setDraft(parseFloat(range.value)); });
    if (nameIn) {
      nameIn.addEventListener('input', function () { saveMsg(''); paintSave(); });
      nameIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doSave(); } });
    }
 
    /* tap for a millimetre, hold to keep going */
    var holdT = null;
    function stopHold() { if (holdT) { clearTimeout(holdT); holdT = null; } }
    $$('[data-inc]').forEach(function (b) {
      var dir = +b.getAttribute('data-inc');
      b.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        e.preventDefault();
        stopHold();
        bump(dir);
        var n = 0;
        (function loop(delay) {
          holdT = setTimeout(function () { bump(dir); n++; loop(n > 12 ? 35 : 75); }, delay);
        })(420);
      });
      ['pointerup', 'pointerleave', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
        b.addEventListener(ev, stopHold);
      });
      b.addEventListener('click', function (e) { if (e.detail === 0) bump(dir); });
      b.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    });
    window.addEventListener('pointerup', stopHold);
    window.addEventListener('blur', stopHold);
 
    /* the shopper changed size or color on the theme's own buttons */
    scope.addEventListener('change', function (e) {
      if (sizeWrap.contains(e.target) || (colorWrap && colorWrap.contains(e.target))) paintSoon();
    });
    /* saved or deleted in another tab, or on the size finder */
    document.addEventListener('ks:sizes', paintSoon);
    window.addEventListener('pageshow', function (e) { if (e.persisted) paintSoon(); });
 
    /* ---------- on arrival ---------- */
    var q = new URLSearchParams(location.search);
    var qFoot = parseFloat(q.get('ks_foot'));
    if (qFoot >= 10 && qFoot <= 40) {
      var qFit = KS.fits[q.get('ks_fit')] ? q.get('ks_fit') : 'comfort';
      var qSocks = q.get('ks_socks') === '1';
      var hit = SV ? SV.match(qFoot, qFit, qSocks) : null;
      if (hit) { S.src = 'p'; S.pid = hit.id; }
      else { S.src = 'u'; S.foot = Math.round(qFoot * 10) / 10; S.fit = qFit; S.socks = qSocks; }
      apply('link');
    } else if (cfg.auto && SV && !q.get('variant')) {
      var list = SV.list();
      var kept = cfg.keep ? SV.pick() : '';
      var p0 = (kept && SV.get(kept)) || (list.length === 1 ? list[0] : null);
      if (p0) { S.src = 'p'; S.pid = p0.id; apply('auto'); }
      else paint();
    } else {
      paint();
    }
  }
 
  window.KSHelper = init;
  document.querySelectorAll('[data-ksh]').forEach(init);
  if (!window.__kshBound) {
    window.__kshBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('[data-ksh]') : null;
      if (r) init(r);
    });
  }
})();
